import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckIcon } from 'lucide-react';
const INCLUDED = ['12 sesiones individuales (~55 min cada una)', 'Material semanal personalizado', 'Acceso directo por WhatsApp durante el programa', 'Los 5 pilares: Cuerpo · Mente · Identidad · Familia · Propósito', 'Sesión de cierre + Plan de 90 días', 'Acceso de por vida a todos los materiales', 'Mes de seguimiento post-programa'];
export function InvestmentSection() {
  return <section id="investment" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-187" data-mp="2bsb3gvhqoxu9">
      <div className="max-w-5xl mx-auto px-6" data-id="element-188" data-mp="26yoy7odwnw8h">
        <FadeIn className="text-center mb-10 md:mb-14" data-id="element-189" data-mp="221yhcyua0wm0">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-sand" data-id="element-190" data-mp="21zcbd3n1ap5w">
            La inversión
          </h2>
        </FadeIn>

        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-6 md:gap-8 items-stretch" data-id="element-191" data-mp="2uqdrp82gqqr0">
          {/* PRICE */}
          <FadeIn direction="right" data-id="element-192" data-mp="13suy1incox7t">
            <div className="bg-charcoal border border-sand/40 rounded-sm p-8 md:p-10 h-full flex flex-col justify-center text-center" data-id="element-193" data-mp="13tms2p1aumvz">
              <p className="text-xs text-offwhite-dim/60 uppercase tracking-[0.25em]" data-id="element-194" data-mp="u3bdm8jzovau">
                Programa completo · 12 semanas
              </p>
              <p className="mt-5 text-5xl md:text-6xl font-heading font-bold text-offwhite" data-id="element-195" data-mp="z13evt6ixtrp">
                $1.200{' '}
                <span className="text-xl text-offwhite-dim font-medium" data-id="element-196" data-mp="k78d174sd4q0">
                  USD
                </span>
              </p>
              <div className="mt-6 pt-6 border-t border-charcoal-light space-y-1" data-id="element-197" data-mp="b4pfn2jrrkb5">
                <p className="text-lg text-sand font-heading font-bold" data-id="element-198" data-mp="g3iryrnbl59q">
                  $100 por semana
                </p>
                <p className="text-offwhite-dim" data-id="element-199" data-mp="25i736pk6ch66">$14 por día</p>
              </div>
              <div className="mt-8" data-id="element-200" data-mp="2ah9wjcqskyyb">
                <Button href="https://wa.link/we351n" size="md" withArrow fullWidth data-id="element-201" data-mp="2ag8nfdtc6mj8">
                  Agendar llamada gratuita
                </Button>
                <p className="mt-4 text-xs text-offwhite-dim/60 uppercase tracking-wider" data-id="element-202" data-mp="243nvpa7b905q">
                  30 minutos · Sin compromiso
                </p>
              </div>
            </div>
          </FadeIn>

          {/* WHAT'S INCLUDED */}
          <FadeIn direction="left" delay={0.15} data-id="element-203" data-mp="2rpuf0sm6q2b9">
            <div className="bg-charcoal border border-charcoal-light rounded-sm p-8 md:p-10 h-full flex flex-col" data-id="element-204" data-mp="2rsowqcdtd90z">
              <h3 className="text-lg font-heading font-bold text-offwhite uppercase tracking-wider mb-6" data-id="element-205" data-mp="2i0sy907tfgw8">
                Lo que está incluido
              </h3>
              <ul className="space-y-4" data-id="element-206" data-mp="2d1ptlgvqzcos">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-3" data-id="element-207" data-mp="3aiyb0kmvkr91">
                    <CheckIcon className="w-5 h-5 text-sand shrink-0 mt-0.5" data-id="element-208" data-mp="35qdhzlbsmi6k" />
                    <span className="text-offwhite-dim" data-id="element-209" data-mp="3d21mifyiq77k">{item}</span>
                  </li>)}
              </ul>
              <p className="mt-auto pt-8 text-offwhite-dim leading-relaxed border-t border-charcoal-light mt-8" data-id="element-210" data-mp="3i1xs2jmv66p8">
                Trabajo con{' '}
                <strong className="text-offwhite font-medium" data-id="element-211" data-mp="3n22868jv0zex">
                  10 personas a la vez
                </strong>
                . No más. Eso requiere mi atención directa.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}